import { useEffect } from "react";
import { useDispatch } from "src/redux/hooks";
import {
  resumeAutosave,
  suspendAutosave,
} from "src/redux/slices/entrySlice";

/**
 * Ref-count suspend for autosave while a transient UI surface is open (e.g. dropdown).
 */
export const useSuspendAutosave = (active: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!active) return;
    dispatch(suspendAutosave());
    return () => {
      dispatch(resumeAutosave());
    };
  }, [active, dispatch]);
};
